import { render, staticRenderFns } from "./BulkMarkAsPaid.vue?vue&type=template&id=2842dba8&scoped=true"
import script from "./BulkMarkAsPaid.vue?vue&type=script&lang=js"
export * from "./BulkMarkAsPaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2842dba8",
  null
  
)

export default component.exports